import './index-edit/endpoint'
import './page-select/endpoint'
import './file-select/endpoint'
import './tag-select/endpoint'
import './nav-edit/endpoint'
import './page-edit/endpoint'
import './place-edit/endpoint'
import './contact-edit/endpoint'
import './date-list-edit/endpoint'
import './tree-edit/endpoint'

import * as formCheckSingle from './../../zzl-lib/form-check-single'
formCheckSingle.register('.js-form-check-single')
